export class AsyncDownloadDialogDataObject {
	/**
	 * @param {AsyncDownloadType} type
	 * @param {Object} [params={}]
	 * @param {?AsyncDownlaodFormat} [format=null]
	 * @param {string} [fileName='']
	 */
	constructor(type, params = {}, format = null, fileName = '') {
		this.type = type;
		this.params = params;
		this.format = format;
		this.fileName = fileName;
	}
}